import { Link } from "react-router-dom";
import { X, ClipboardList } from "lucide-react";
import { dayLabels, fmtH } from "../lib/planning";

/** Tabella assegnazioni dipendente↔cantiere (usata nella scheda dipendente e nella pagina Assegnazioni). */
export function AssignmentsTable({ rows, onDelete, showEmployee = true, showWorksite = true, emptyText, testPrefix = "asg" }) {
    if (!rows.length) {
        return <div className="rounded-md border border-dashed border-slate-200 bg-slate-50/60 p-6 text-center text-sm text-slate-500" data-testid={`${testPrefix}-empty`}>{emptyText || "Nessuna assegnazione"}</div>;
    }
    return (
        <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
                <thead>
                    <tr className="border-b border-slate-200 text-[10px] font-bold uppercase tracking-wide text-slate-400">
                        {showEmployee && <th className="px-3 py-2">Dipendente</th>}
                        {showWorksite && <th className="px-3 py-2">Cliente / Cantiere</th>}
                        <th className="px-3 py-2">Attività</th>
                        <th className="px-3 py-2">Giorni</th>
                        <th className="px-3 py-2">Orario</th>
                        <th className="px-3 py-2">Frequenza</th>
                        <th className="px-3 py-2 text-right">Ore/sett.</th>
                        <th className="px-2 py-2" />
                    </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                    {rows.map((r) => (
                        <tr key={r.id} className="hover:bg-slate-50/70" data-testid={`${testPrefix}-row-${r.id}`}>
                            {showEmployee && (
                                <td className="px-3 py-2">
                                    <Link to={`/dipendenti/${r.employee_id}`} className="font-semibold text-slate-700 hover:text-[#376DB3] hover:underline">{r.employee_name}</Link>
                                    {r.matricola && <span className="ml-1.5 text-[11px] text-slate-400">matr. {r.matricola}</span>}
                                    {!r.timbratura_enabled && <span className="ml-1.5 rounded bg-sky-50 px-1.5 py-0.5 text-[10px] font-bold text-sky-700" title="Timbratura non abilitata">NO TIMBR.</span>}
                                </td>
                            )}
                            {showWorksite && (
                                <td className="px-3 py-2">
                                    <Link to={`/presenze/cantieri/${r.worksite_id}`} className="font-semibold text-slate-700 hover:text-[#376DB3] hover:underline">{r.worksite_name}</Link>
                                    {r.client_name && <div className="text-[11px] text-slate-400">{r.client_name}</div>}
                                </td>
                            )}
                            <td className="px-3 py-2">
                                <span className="inline-flex items-center gap-1 text-slate-700"><ClipboardList className="h-3.5 w-3.5 text-[#376DB3]" /> {r.activity_name}</span>
                            </td>
                            <td className="px-3 py-2 text-xs text-slate-600">{r.days?.length ? dayLabels(r.days) : <span className="italic text-slate-400">secondo date</span>}</td>
                            <td className="whitespace-nowrap px-3 py-2 font-mono-numbers text-xs text-slate-600">{r.start}–{r.end} <span className="text-slate-400">({fmtH(r.hours_intervention)} h)</span></td>
                            <td className="px-3 py-2 text-xs text-slate-600">{r.frequency_label}</td>
                            <td className="px-3 py-2 text-right font-mono-numbers text-xs font-semibold text-slate-700">{fmtH(r.hours_week)}</td>
                            <td className="px-2 py-2 text-right">
                                {onDelete && (
                                    <button type="button" onClick={() => onDelete(r)} className="text-slate-300 hover:text-red-500" title="Rimuovi assegnazione" data-testid={`${testPrefix}-del-${r.id}`}>
                                        <X className="h-4 w-4" />
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
